import {useEffect, useRef, useState} from "react";

export default function useHoverDropdown() {
  const [open, setOpen] = useState(false);
  const [openedByHover, setOpenedByHover] = useState(false);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined,
  );
  const dismissed = useRef(false);

  const cancelClose = () => clearTimeout(closeTimer.current);
  const show = () => {
    cancelClose();
    dismissed.current = false;
    setOpenedByHover(false);
    setOpen(true);
  };
  const close = () => {
    cancelClose();
    dismissed.current = true;
    setOpen(false);
  };
  const onMouseEnter = () => {
    cancelClose();
    if (!open && !dismissed.current) {
      setOpenedByHover(true);
      setOpen(true);
    }
  };
  const onMouseLeave = () => {
    cancelClose();
    dismissed.current = false;
    closeTimer.current = setTimeout(() => setOpen(false), 150);
  };

  useEffect(() => () => clearTimeout(closeTimer.current), []);

  return {
    open,
    openedByHover,
    show,
    close,
    triggerProps: {onMouseEnter, onMouseLeave},
    paperProps: {onMouseEnter: cancelClose, onMouseLeave},
  };
}
